import { useMemo } from "react";
import { TableNames } from "@/convex/_generated/dataModel";

// Define valid table names excluding auth tables
type ValidTableNames = Exclude<
  TableNames,
  | "authAccounts"
  | "authRateLimits"
  | "authRefreshTokens"
  | "authSessions"
  | "authVerificationCodes"
  | "authVerifiers"
>;

// Definir el número de columnas visibles para cada tabla en la UI
const TABLE_COLUMN_COUNTS: Partial<Record<ValidTableNames, number>> = {
  clients: 7, // nombre, email, teléfono, tipo, estado, acciones, etc.
  products: 8, // nombre, tipo, categoría, precio, estado, código, acciones, etc.
  quotations: 8, // número, cliente, título, estado, monto, fecha, acciones, etc.
  quotations_items: 6, // nombre, cantidad, precio unitario, subtotal, acciones, etc.
  suppliers: 7, // código, empresa, contacto, email, teléfono, estado, acciones
  nomenclature: 6, // tabla, prefijo, formato fecha, dígitos, frecuencia, acciones
  invoices: 8, // número, cliente, fecha, estado, monto, acciones, etc.
  invoices_cancelation_requests: 8, // número, cliente, fecha, estado, monto, acciones, etc.
  invoices_payments: 8, // número, cliente, fecha, estado, monto, acciones, etc.
  // Agregar más tablas según sea necesario
};

// Hook para obtener el número de columnas
export function useColumnCount<T extends ValidTableNames>(
  tableName: T,
): number {
  return useMemo(() => {
    return TABLE_COLUMN_COUNTS[tableName] || 0;
  }, [tableName]);
}

// Hook para obtener todas las definiciones de columnas
export function useAllTableColumnCounts(): Partial<
  Record<ValidTableNames, number>
> {
  return useMemo(() => TABLE_COLUMN_COUNTS, []);
}

// Función helper para obtener el número de columnas sin hook (para uso en componentes server)
export function getColumnCount<T extends ValidTableNames>(
  tableName: T,
): number {
  return TABLE_COLUMN_COUNTS[tableName] || 0;
}
